module.exports = __webpack_public_path__ + "static/media/main31.fd2f69cf.png";